module.exports = __webpack_public_path__ + "static/media/Vanuatu.d9d14c54.png";